export default [
  {
    name: 'Без отопления',
    key: 'no',
  },
  {
    name: 'Центральное',
    key: 'central',
  },
  {
    name: 'Автономное',
    key: 'autonomous',
  },
  {
    name: 'Котел',
    key: 'boiler',
  },
  {
    name: 'Печь',
    key: 'stove',
  },
  {
    name: 'Камин',
    key: 'fireplace',
  },
  {
    name: 'Другое',
    key: 'other',
  },
  {
    name: 'Центральное газовое',
    key: 'centralGas',
  },
  {
    name: 'Центральное угольное',
    key: 'centralCoal',
  },
  {
    name: 'Электрическое',
    key: 'electric',
  },
  {
    name: 'Автономное газовое',
    key: 'autonomousGas',
  },
  {
    name: 'Дизельное',
    key: 'diesel',
  },
  {
    name: 'Твердотопливный котел',
    key: 'solidFuelBoiler',
  },
];
